export default __webpack_public_path__ + "static/rc_logo-7850f943426f5b0c29e466286f64dd18.png";